const env = import.meta.env
export const API_RENDER_PATH =
  window.API_RENDER_HOST || '//api.local.renderforest.com/api/v1'
export const CURRENT_USER_API_PATH = '/users/me'
export const RECOMMENDATION_API_PATH =
  window.RECOMMENDATION_API_PATH ||
  env.VITE_RECOMMENDATION_API_PATH ||
  'https://recommendation-api-4.local.renderforest.com/api/v1'
export const VIDEO_API_PATH =
  window.VIDEO_API_PATH ||
  env.VITE_VIDEO_API_PATH ||
  'https://video-api.local.renderforest.com/api/v1'

export const FILE_UPLOAD_PATH =
  window.FILE_UPLOAD_PATH ||
  env.VITE_FILE_UPLOAD_PATH ||
  '//user-media-upload-3.local.renderforest.com/api/v3'

export const FILE_UPLOAD_URL = `${FILE_UPLOAD_PATH}/user-media`

export const VIDEO_PROJECTS_API_PATH = `${VIDEO_API_PATH}/video-projects`
export const FONTS_API_PATH = `${VIDEO_API_PATH}/fonts`

export const AI_VIDEO_API_PATH =
  window.AI_VIDEO_API_PATH ||
  env.VITE_AI_VIDEO_API_PATH ||
  '//ai-video-api-1.local.renderforest.com/api/v1'
export const AI_IMAGE_API_PATH =
  window.AI_IMAGE_API_PATH ||
  env.VITE_AI_IMAGE_API_PATH ||
  '//ai-image-api-1.local.renderforest.com/api/v1'

export const AI_IMAGE_GENERATOR_API_PATH = `${AI_IMAGE_API_PATH}/image-generator`
export const AI_IMAGE_PROJECT_API_PATH = `${AI_IMAGE_API_PATH}/image-projects`

const SPEECH_API_PATH =
  window?.SPEECH_API_PATH || '//speech-api-1.local.renderforest.com/api/v1'

export const TTS_SPEECH_API_PATH = `${SPEECH_API_PATH}/text-to-speech`

export const CREDIT_MANAGER_API =
  window.CREDIT_MANAGER_API_PATH ||
  '//credit-manager.local.renderforest.com/api/v1'

export const MEDIAS_API_PATH =
  window.MEDIAS_API_PATH ||
  env.VITE_MEDIAS_API_PATH ||
  '//medias-api.local.renderforest.com/api/v1'
